<template>
    <el-form-item :label="data.label">
        <template v-if="data.type == 1" >
            <div class="box">
                <el-input
                type="text"
                :placeholder="data.placeholder"
                :disabled="true"
            ></el-input>
            <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>
        <template v-if="data.type == 2" >
            <div class="box">
                <el-checkbox-group v-model="data.value">
                    <el-checkbox :label="item.label" v-for="(item,index) in data.option" :key="index" :value="item.value" disabled/>
                </el-checkbox-group>
                <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 3" >
            <div class="box">
                <el-select v-model="data.value" :placeholder="data.placeholder">
                    <el-option :label="item.label" v-for="(item,index) in data.option" :key="index" :value="item.value" />
                </el-select>
                <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>
        <template v-if="data.type == 4" >
            <div class="box">
                <el-radio-group v-model="data.value" class="ml-4">
                    <el-radio size="large" :label="item.label" v-for="(item,index) in data.option" :key="index" :value="item.value" disabled></el-radio>
                </el-radio-group>
                <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 5" >
            <div class="box">
                <el-cascader
                    v-model="data.value"
                    :options="data.option"
                    />
                <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 6" >
            <div class="box">
                <el-date-picker
                    v-model="data.value"
                    type="date"
                    :placeholder="data.placeholder"
                    size="small"
                />
                <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 7" >
            <div class="box">
                <h1>{{ data.value }}</h1>
            </div>
        </template>

        <template v-if="data.type == 8" >
            <div class="box">
                <el-input
                type="textarea" :rows="3"
                :placeholder="data.placeholder"
                v-model="data.value "
            ></el-input>
            <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>
        <template v-if="data.type == 9" >
            <div class="box">
                <el-input
                type="text" 
                placeholder="国家/省市/区县"
                :disabled="true"
            ></el-input>
            <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 10" >
            <div class="box">
                <el-input
                type="number" 
                :placeholder="data.placeholder"
                :disabled="true"
            ></el-input>
            <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 11 || data.type == 13" >
            <div class="box">
                <div class="updata_pic">+</div>
            <span class="must" v-if="data.must == '1'">必填</span>
            </div>
        </template>

        <template v-if="data.type == 12" >
            <div class="box">
                <el-divider border-style="double" />
            </div>
        </template>
    </el-form-item>
</template>

<script>
    export default {
        name: 'GenerateFormItem',
        props: {
            data: {
                type: Array,
                default: []
            },
            
        },
        setup(props,){

        }
    }
</script>
<style lang="less" scoped>
.box{
    display: flex;
    .must{
        color: red;
        margin-left: 10px;
        flex-shrink: 0; 
    }
    .updata_pic{
        width: 50px;
        height: 50px;
        border: 1px dashed #999;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ddd;
    }
}
</style>